import { Link, useLocation } from "react-router";
import { landing } from "@historia/shared/content";
import { MenuConta } from "@/components/ui/MenuConta";
import { LINKS, eAtivo } from "@/components/ui/ligacoes";
import { useUnreadCount } from "@/api/queries";

/**
 * Barra de cima.
 *
 * No desktop é o que sempre foi: os destinos em linha e o "Sair" à direita.
 *
 * No telemóvel deixou de ser navegação. O hamburger e o painel que abria por
 * baixo desapareceram — quem navega agora é a `BarraInferior`, ao alcance do
 * polegar. O que fica em cima é o cabeçalho de uma app: o nome dela, e a conta.
 *
 * A conta voltou a ser um hamburger (IDEA-044), o que à primeira vista desfaz o
 * parágrafo acima e não desfaz: aquele abria os destinos da app, este abre as
 * Definições e o Sair. A navegação continua toda em baixo.
 *
 * Chegou a mostrar aqui o nome da secção aberta, de quando o carrossel, parado,
 * só mostrava ícones. Deixou de fazer falta: as etiquetas dos ícones estão à
 * vista por omissão e é lá em baixo, ao lado do dourado, que se lê onde se
 * está. Dizê-lo duas vezes no mesmo ecrã não acrescentava nada — e o nome da
 * app é o que faz isto parecer uma app quando se abre do ecrã inicial.
 */
export function Navegacao() {
  const pathname = useLocation().pathname;
  const porLer = useUnreadCount().data?.naoLidas ?? 0;

  return (
    <header className="sticky top-0 z-30 border-b border-ouro/15 bg-creme/85 backdrop-blur-sm">
      <nav className="mx-auto flex max-w-4xl items-center justify-between gap-2 px-4 py-2.5 sm:px-5 sm:py-3">
        {/* Telemóvel: o nome da app. Também leva a casa — é o que se espera de
            um nome no cimo do ecrã, e poupa uma passagem pelo carrossel. */}
        <Link
          to="/"
          className="font-display text-lg font-semibold text-tinta transition-colors hover:text-ouro-600 sm:hidden"
        >
          {landing.titulo}
        </Link>

        {/* Desktop: os destinos em linha, como antes. */}
        <ul className="hidden items-center gap-1 text-sm sm:flex">
          {LINKS.map((link) => {
            const ativo = eAtivo(pathname, link.href);
            const marca = link.href === "/notificacoes" && porLer > 0;
            return (
              <li key={link.href}>
                <Link
                  to={link.href}
                  aria-current={ativo ? "page" : undefined}
                  className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-2 font-semibold transition-colors ${
                    ativo
                      ? "bg-ouro/15 text-ouro-600"
                      : "text-tinta-700 hover:bg-creme-200/70 hover:text-ouro-600"
                  }`}
                >
                  {link.etiqueta}
                  {/* No desktop há espaço para o número, ao contrário da barra
                      do telemóvel — e um número diz mais do que um ponto. */}
                  {marca && (
                    <span className="rounded-full bg-ouro px-1.5 py-0.5 text-[10px] font-semibold leading-none text-creme-50">
                      {porLer > 9 ? "9+" : porLer}
                    </span>
                  )}
                </Link>
              </li>
            );
          })}
        </ul>

        {/* A conta — em todos os tamanhos. Era só o "Sair"; passou a hamburger
            quando ganhou companhia (IDEA-044). Ver MenuConta.tsx para porque é
            que isto não desfaz o IDEA-027. */}
        <div className="flex items-center gap-1">
          <MenuConta />
        </div>
      </nav>
    </header>
  );
}
